import { Rule } from "antd/es/form";

interface forgotPasswordValidatorRules {
  email: Rule[];
  password: Rule[];
  recaptcha: Rule[];
  otpCode: Rule[];
}

export const forgotPasswordValidatorRules: forgotPasswordValidatorRules = {
  email: [
    { required: true, message: "Please input your email." },
  ],
  password: [
    { required: true, message: "Please input your password." },
  ],
  otpCode: [
    { required: true, message: "Please enter OTP sent to your email address." },
  ],
  recaptcha: [
    { validator: (_: any, value: string | null) => {
        if (!value) {
          return Promise.reject(new Error("Please complete the verification step to continue."));
        }
        return Promise.resolve();
      }
    },
  ],
};
